module.exports = __webpack_public_path__ + "static/media/bg-music-waterfall.db89081e.jpg";